export type FinancialYearOption = {
  label: string;
  value: number | null;
};

const STORAGE_KEY = 'selectedFinancialYear';

export function getCurrentFinancialYear(referenceDate = new Date()): number {
  return referenceDate.getFullYear();
}

export function getFinancialYearOptions(count = 2, referenceDate = new Date()): FinancialYearOption[] {
  const currentYear = getCurrentFinancialYear(referenceDate);
  const yearOptions: FinancialYearOption[] = Array.from({ length: count }, (_, index) => {
    const year = currentYear - index;
    return {
      label: String(year),
      value: year,
    };
  });

  return [{ label: 'All years', value: null }, ...yearOptions];
}

export function isAllowedFinancialYear(year: number, referenceDate = new Date()): boolean {
  const currentYear = getCurrentFinancialYear(referenceDate);
  return year === currentYear || year === currentYear - 1;
}

export function getStoredFinancialYear(): number | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw || raw === 'all') {
      return null;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

export function storeFinancialYear(year: number | null): void {
  if (year == null) {
    sessionStorage.setItem(STORAGE_KEY, 'all');
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, String(year));
}
